module.exports = __webpack_public_path__ + "img/lichphatsong-1597510677441.1fa03281.jpg";